module.exports = __webpack_public_path__ + "static/media/aboutUs2.7ffc272f.jpg";